import { Component, OnInit } from '@angular/core';
import { AdminService } from "../services/admin.service";
import { UserService } from "../services/user.service";
import { NotificationsService } from "angular2-notifications";
import { PagerserviceService } from "../services/pagerservice.service";
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-manageip',
  templateUrl: './manageip.component.html',
  styleUrls: ['./manageip.component.css']
})
export class ManageipComponent implements OnInit {

  constructor(private adminservice: AdminService,
    private userService: UserService,
    private notifSer: NotificationsService,
    private pagerService: PagerserviceService,
    private router: Router,
  ) { }
  dataobj = {
    ip_addr: '',
    _csrf: '',
    search: '',
    username: 'Added by admin'
  }
  ipobj = {
    _id: '',
    _csrf: '',
    status: '',
    checkedIP: [],
    ip_addr: ''
  }
  checkedIP: Array<any> = [];
  ipList: Array<any>;
  iparray: Array<any> = [];
  hideipbutton = true;
  ipform = false;
  ipListstatus = true;
  ipListlength: any;
  validateip = true;
  permission: string;
  Tpager: number;
  pager1: any = {};
  pager: number;
  currentPage: number;

  ngOnInit() {
    if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
      var spt = this.router.url.split("/");
      var menu_url = spt[1];
      var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
      var adminrules = JSON.parse(localStorage.getItem('adminrules'));
      var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
      if (index != -1) {
        var menuid = adminmenus[index]._id;
        var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
        this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
      }
    }
    this.csrf();
    this.dataobj['FilPerpage'] = 10
    this.dataobj['FilPage'] = 1
  }
  showIpForm() {
    this.ipform = true
    this.ipListstatus = false;
    this.hideipbutton = false;
  }
  hideIPForm() {
    this.ipListstatus = true;
    this.ipform = false;
    this.hideipbutton = true;
  }
  csrf() {
    this.userService.csrf().subscribe((success) => {
      this.dataobj._csrf = success._csrf;
      this.ipobj._csrf = success._csrf;
      this.getallIpList();
    }, (error) => {
      this.notifSer.error(
        'Error',
        error.error.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
    })
  }
  /**
   * get all ip list
   */
  getallIpList() {
    this.adminservice.getAllIpaddr(this.dataobj).subscribe(async (response) => {
      this.ipList = response.result;
      this.ipListlength = this.ipList.length;
      this.iparray = [];
      for (let index = 0; index < this.ipList.length; index++) {
        this.iparray.push(this.ipList[index].ip_addr)
      }
      this.currentPage = response.current;
      this.Tpager = response.pages;
      this.setPage(this.dataobj['FilPage']);
    })
  }
  /**
   * save ip address
   */
  saveip(ip: NgForm) {
    if (this.validateip == true && this.dataobj.ip_addr) {
      this.adminservice.addIpAddr(this.dataobj).subscribe(data => {
        if (data) {
          this.notifSer.success(
            'Success',
            data.message,
            {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
          )
          ip.resetForm();
          this.ipListstatus = true;
          this.ipform = false;
          this.hideipbutton = true;
          this.getallIpList();
        }
      }, (err) => {
        this.notifSer.error(
          'Error',
          err.error.message,
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
          }
        )
      })
    } else {

    }
  }
  /**
   * search filter based ip address
   * @param event
   */
  sreach(event: any) {
    this.dataobj.search = event.target.value;
    this.getallIpList();
  }
  /**
   * validate ip address
   * @param ipaddress
   */
  ValidateIPaddress(ipaddress) {
    var ipv6 = (/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/.test(ipaddress));
    var ipv4 = (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress))
    if (ipv6 || ipv4) {
      this.validateip = true;
    }
    else {
      if (ipaddress == '') {
        this.validateip = true;
      } else {
        this.validateip = false;
      }
    }
  }
  /**
   * delete single ip
   * @param ip_id
   */
  deleteIP(ip) {
    this.ipobj._id = ip._id;
    this.ipobj['ip_addr'] = ip.ip_addr;
    this.adminservice.deleteIp(this.ipobj).subscribe((data) => {
      this.notifSer.success(
        'Success',
        data.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
      this.getallIpList();
    }, (err) => {
      this.notifSer.error(
        'Error',
        err.error.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
    });
  }
  deleteAllIP() {
    var ipobject = {
      _csrf: this.ipobj._csrf,
      iparray: this.iparray
    }
    this.adminservice.deleteAllIp(ipobject).subscribe((data) => {
      this.notifSer.success(
        'Success',
        data.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
      this.getallIpList();
    }, (err) => {
      this.notifSer.error(
        'Error',
        err.error.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
    });
  }
  changeIPStatus(ip, status) {
    this.ipobj.ip_addr = ip.ip_addr;
    this.ipobj.status = status;
    this.adminservice.IpAddrStatus(this.ipobj).subscribe((data) => {
      var ipobjs = data.result;
      if (ipobjs) {
        if (status == '0') {
          var ipobj = {
            ip_addr: '',
            status: ''
          }
          ipobj.ip_addr = ip.ip_addr;
          ipobj.status = '0'
        }
      }
      this.getallIpList();
      this.notifSer.success(
        'Success',
        data.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
    }, (err) => {
      this.notifSer.error(
        'Error',
        err.error.message,
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
    })
  }

  checkip(event, ip) {
    if (event.target.checked) {
      this.checkedIP.push(ip)
    } else {
      var index = this.checkedIP.indexOf(ip)
      this.checkedIP.splice(index, 1);
    }
    this.ipobj.checkedIP = this.checkedIP;
  }
  deleteCheckedIP() {
    if (this.ipobj.checkedIP.length !== 0) {
      this.adminservice.deleteCheckedIP(this.ipobj).subscribe((result) => {
        this.getallIpList();
        this.notifSer.success(
          'Success',
          result.message,
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
          }
        )
      }, (error) => {
        this.notifSer.error(
          'Error',
          error.error.message,
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
          }
        )
      })
    } else {
      this.notifSer.error(
        'Error',
        'Please Select Any of these',
        {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50
        }
      )
    }
  }
  /* Pagination of customer details */
  setPage(page: number) {
    // get pager object from service
    this.pager1 = this.pagerService.getPager(this.Tpager, page);
  }
  setPageOnClick(page: number) {
    this.pager = page;
    this.dataobj['FilPage'] = this.pager;
    this.getallIpList();
  }

}



// WEBPACK FOOTER //
// ./src/app/manageip/manageip.component.ts